export default __webpack_public_path__ + "static/media/burger-menu-icon.f877aa0c.svg";